// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAT2pdqxncgkHtrfXdlxsEA8HwO-SAa9Dg",
    authDomain: "kurut-phone.firebaseapp.com",
    projectId: "kurut-phone",
    storageBucket: "kurut-phone.firebasestorage.app",
    messagingSenderId: "267483881575",
    appId: "1:267483881575:web:7f4bb44711d1fcbe65f4c2",
    measurementId: "G-P302M4GQ58"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, "us-central1");
export { app, auth, db, functions };
auth.languageCode = 'ru';